module.exports = {
	"notification.message": "Wix.com uses cookies to give you the best possible experience.",
	"notification.more.info": "Read More",
	"notification.got.it": "Got It"
};


//////////////////
// WEBPACK FOOTER
// ./assets/locale/messages_en.json
// module id = 39
// module chunks = 0